import Vue from 'vue'
import sObjetos from '@/aplicacao/_servicos/objetos'

const State = () => ({

    encartes: 0,

    encartesVirtuais: 0,

    box: 0,

    midiasSociais: 0,

    acoesWhatsapp: 0,

    vendasWhatsMidias: 0,

    boasPraticas: {
        aprovacao: 0,
        correcao: 0,
    },

    chamados: 0,

    artesDigitais: 0,

    solicitacoesDeCadastro: 0,

})

const mutations = {

    resetar(stateParam) {
        sObjetos.preencher(stateParam, State())
    },

    setEncartes(state, payload) {
        state.encartes = payload
    },

    setEncartesVirtuais(state, payload) {
        state.encartesVirtuais = payload
    },

    setBox(state, payload) {
        state.box = payload
    },

    setMidiasSociais(state, payload) {
        state.midiasSociais = payload
    },

    setAcoesWhatsapp(state, payload) {
        state.acoesWhatsapp = payload
    },

    setVendasWhatsMidias(state, payload) {
        state.vendasWhatsMidias = payload
    },

    setBoasPraticasAprovacao(state, payload) {
        state.boasPraticas.aprovacao = payload
    },

    setBoasPraticasCorrecao(state, payload) {
        state.boasPraticas.correcao = payload
    },

    setChamados(state, payload) {
        state.chamados = payload
    },

    setArtesDigitais(state, payload) {
        state.artesDigitais = payload
    },

    setSolicitacoesDeCadastro(state, payload) {
        state.solicitacoesDeCadastro = payload
    },

}

const actions = {

    resetar({ commit }, payload) {
        commit('resetar', payload)
    },

    setEncartes({ commit, getters }, payload) {
        commit('setEncartes', getters.temPermissaoPendencia('ROLE_ENCARTE_PENDENCIAS') ? payload : 0)
    },

    setEncartesVirtuais({ commit, getters }, payload) {
        commit('setEncartesVirtuais', getters.temPermissaoPendencia('ROLE_ENCARTE_VIRTUAL_PENDENCIAS') ? payload : 0)
    },

    setBox({ commit, getters }, payload) {
        commit('setBox', getters.temPermissaoPendencia('ROLE_BOX_PENDENCIAS') ? payload : 0)
    },

    setMidiasSociais({ commit, getters }, payload) {
        commit('setMidiasSociais', getters.temPermissaoPendencia('ROLE_MIDIA_SOCIAL_PENDENCIAS') ? payload : 0)
    },

    setAcoesWhatsapp({ commit, getters }, payload) {
        commit('setAcoesWhatsapp', getters.temPermissaoPendencia('ROLE_ACOES_WHATSAPP_PENDENCIAS') ? payload : 0)
    },

    setVendasWhatsMidias({ commit, getters }, payload) {
        commit('setVendasWhatsMidias', getters.temPermissaoPendencia('ROLE_VENDAS_VIA_WHATSAPP_E_MIDIAS_SOCIAIS_PENDENCIAS') ? payload : 0)
    },

    setBoasPraticasAprovacao({ commit, getters }, payload) {
        commit('setBoasPraticasAprovacao', getters.temPermissaoPendencia('ROLE_BOAS_PRATICAS_APROVAR') ? payload : 0)
    },

    setBoasPraticasCorrecao({ commit, getters }, payload) {
        commit('setBoasPraticasCorrecao', getters.temPermissaoPendencia('ROLE_BOAS_PRATICAS_POSTAR') ? payload : 0)
    },

    setChamados({ commit, getters }, payload) {
        commit('setChamados', getters.temPermissaoPendencia('ROLE_AJUDA_CHAMADOS') ? payload : 0)
    },

    setArtesDigitais({ commit, getters }, payload) {
        commit('setArtesDigitais', getters.temPermissaoPendencia('ROLE__ARTES_DIGITAIS') ? payload : 0)
    },

    setSolicitacoesDeCadastro({ commit, getters }, payload) {
        commit('setSolicitacoesDeCadastro', getters.temPermissaoPendencia('ROLE__FERRAMENTAS__SOLICITACOES_DE_CADASTRO') ? payload : 0)
    },

    setPendencias({ dispatch }, payload) {
        dispatch('setEncartes', payload.hasOwnProperty('encartes') ? payload.encartes : 0)
        dispatch('setEncartesVirtuais', payload.hasOwnProperty('encartesVirtuais') ? payload.encartesVirtuais : 0)
        dispatch('setBox', payload.hasOwnProperty('box') ? payload.box : 0)
        dispatch('setMidiasSociais', payload.hasOwnProperty('midiasSociais') ? payload.midiasSociais : 0)
        dispatch('setAcoesWhatsapp', payload.hasOwnProperty('acoesWhatsapp') ? payload.acoesWhatsapp : 0)
        dispatch('setVendasWhatsMidias', payload.hasOwnProperty('vendasWhatsMidias') ? payload.vendasWhatsMidias : 0)
        dispatch('setBoasPraticasAprovacao', payload.hasOwnProperty('boasPraticas') ? payload.boasPraticas.aprovacao : 0)
        dispatch('setBoasPraticasCorrecao', payload.hasOwnProperty('boasPraticas') ? payload.boasPraticas.correcao : 0)
        dispatch('setChamados', payload.hasOwnProperty('chamados') ? payload.chamados : 0)
        dispatch('setArtesDigitais', payload.hasOwnProperty('artesDigitais') ? payload.artesDigitais : 0)
        dispatch('setSolicitacoesDeCadastro', payload.hasOwnProperty('solicitacoesDeCadastro') ? payload.solicitacoesDeCadastro : 0)
    },

    carregarEncartes({ dispatch, rootState }) {
        Vue.http.get(`encartes/listagem/pendencias/${rootState.sessao.usuario.id}/quantidade`)
            .then(res => res.json())
            .then(res => { dispatch('setEncartes', res.dados.quantidade) })
    },

    carregarEncartesVirtuais({ dispatch, rootState }) {
        Vue.http.get(`encartes-virtuais/listagem/pendencias/${rootState.sessao.usuario.id}/quantidade`)
            .then(res => res.json())
            .then(res => { dispatch('setEncartesVirtuais', res.dados.quantidade) })
    },

    carregarBox({ dispatch, rootState }) {
        Vue.http.get(`box/listagem/pendencias/${rootState.sessao.usuario.id}/quantidade`)
            .then(res => res.json())
            .then(res => { dispatch('setBox', res.dados.quantidade) })
    },

    carregarMidiasSociais({ dispatch, rootState }) {
        Vue.http.get(`midias-sociais/pendencias/${rootState.sessao.usuario.id}/quantidade`)
            .then(res => res.json())
            .then(res => { dispatch('setMidiasSociais', res.dados.quantidade) })
    },

    carregarAcoesWhatsapp({ dispatch, rootState }) {
        Vue.http.get(`acoes-whatsapp/pendencias/${rootState.sessao.usuario.id}/quantidade`)
            .then(res => res.json())
            .then(res => { dispatch('setAcoesWhatsapp', res.dados.quantidade) })
    },

    carregarVendasWhatsMidias({ dispatch, rootState }) {
        Vue.http.get(`vendas-whats-midias/pendencias/${rootState.sessao.usuario.id}/quantidade`)
            .then(res => res.json())
            .then(res => { dispatch('setVendasWhatsMidias', res.dados.quantidade) })
    },

    carregarBoasPraticasAprovacao({ dispatch }) {
        Vue.http.get(`boas-praticas/aprovacao/pendencias/quantidade`)
            .then(res => res.json())
            .then(res => { dispatch('setBoasPraticasAprovacao', res.dados.quantidade) })
    },

    carregarBoasPraticasCorrecao({ dispatch, rootState }) {
        Vue.http.get(`boas-praticas/posts/pendencias/${rootState.sessao.usuario.id}/quantidade`)
            .then(res => res.json())
            .then(res => { dispatch('setBoasPraticasCorrecao', res.dados.quantidade) })
    },

    carregarChamados({ dispatch, rootState }) {
        Vue.http.get(`ajuda/chamado/pendentes/${rootState.sessao.usuario.id}/quantidade`)
            .then(res => res.json())
            .then(res => { dispatch('setChamados', res.dados.quantidade) })
    },

    carregarArtesDigitais({ dispatch }) {
        Vue.http.get(`artes-digitais/pendencias/quantidade`)
            .then((res) => res.json())
            .then((res) => { dispatch('setArtesDigitais', res.dados.quantidade) })
    },

    carregarSolicitacoesDeCadastro({ dispatch }) {
        Vue.http.get(`ferramentas/solicitacao-de-cadastro/pendencias/quantidade`)
            .then((res) => res.json())
            .then((res) => { dispatch('setSolicitacoesDeCadastro', res.dados.quantidade) })
    },

}

const getters = {

    temAlguma: (state, getters) => 0 < getters.quantidadeTotal,
    temEspecifica: state => pendencia => 0 < pendencia.quantidade,
    quantidadeTotal: state => parseInt(state.encartes) + parseInt(state.encartesVirtuais) + parseInt(state.box) + parseInt(state.midiasSociais) + parseInt(state.acoesWhatsapp) + parseInt(state.boasPraticas.aprovacao) + parseInt(state.boasPraticas.correcao) + parseInt(state.chamados) + parseInt(state.vendasWhatsMidias) + parseInt(state.artesDigitais) + parseInt(state.solicitacoesDeCadastro),
    badgeEspecifica: (state, getters) => pendencia => getters.temEspecifica(pendencia) ? 'danger' : 'success',
    temPermissaoMenu: (state, getters, rootState) => rootState.sessao.permissoes.includes('ROLE_ENCARTE_PENDENCIAS') || rootState.sessao.permissoes.includes('ROLE_ENCARTE_VIRTUAL_PENDENCIAS') || rootState.sessao.permissoes.includes('ROLE_BOX_PENDENCIAS') || rootState.sessao.permissoes.includes('ROLE_MIDIA_SOCIAL_PENDENCIAS') || rootState.sessao.permissoes.includes('ROLE_ACOES_WHATSAPP_PENDENCIAS') || rootState.sessao.permissoes.includes('ROLE_BOAS_PRATICAS_POSTAR') || rootState.sessao.permissoes.includes('ROLE_BOAS_PRATICAS_APROVAR') || rootState.sessao.permissoes.includes('ROLE_AJUDA_CHAMADOS') || rootState.sessao.permissoes.includes('ROLE_VENDAS_VIA_WHATSAPP_E_MIDIAS_SOCIAIS_PENDENCIAS') || rootState.sessao.permissoes.includes('ROLE__ARTES_DIGITAIS') || rootState.sessao.permissoes.includes('ROLE__FERRAMENTAS__SOLICITACOES_DE_CADASTRO'),
    temPermissaoPendencia: (state, getters, rootState, rootGetters) => role => rootGetters['sessao/temPermissao'](role),

    formatadas: state => [
        { nome: 'Encarte Exclusivo Impresso', modulo: 'encartes', rota: 'encartes-pendencias', quantidade: state.encartes, permissao: 'ROLE_ENCARTE_PENDENCIAS' },
        { nome: 'Encarte Digital', modulo: 'encartes-virtuais', rota: 'encartes-virtuais-pendencias', quantidade: state.encartesVirtuais, permissao: 'ROLE_ENCARTE_VIRTUAL_PENDENCIAS' },
        { nome: 'Arte Para Box', modulo: 'box', rota: 'box-pendencias', quantidade: state.box, permissao: 'ROLE_BOX_PENDENCIAS' },
        { nome: 'Arte Para Web/Mobile', modulo: 'midias-sociais', rota: 'midias-sociais-pendencias', quantidade: state.midiasSociais, permissao: 'ROLE_MIDIA_SOCIAL_PENDENCIAS' },
        { nome: 'Artes Digitais', modulo: 'artes-digitais', rota: 'artes-digitais-pendencias', quantidade: state.artesDigitais, permissao: 'ROLE__ARTES_DIGITAIS' },
        { nome: 'Vendas via WhatsApp', modulo: 'acoes-whatsapp', rota: 'acoes-whatsapp-pendencias', quantidade: state.acoesWhatsapp, permissao: 'ROLE_ACOES_WHATSAPP_PENDENCIAS' },
        { nome: 'Vendas WhatsApp e Mídias', modulo: 'vendas-whats-midias', rota: 'vendas-whats-midias-pendencias', quantidade: state.vendasWhatsMidias, permissao: 'ROLE_VENDAS_VIA_WHATSAPP_E_MIDIAS_SOCIAIS_PENDENCIAS' },
        { nome: 'Boas Práticas - Aprovações', modulo: 'boas-praticas', rota: 'boas-praticas-aprovacao-listagem', quantidade: state.boasPraticas.aprovacao, permissao: 'ROLE_BOAS_PRATICAS_APROVAR' },
        { nome: 'Boas Práticas - Correções', modulo: 'boas-praticas', rota: 'boas-praticas-meus-posts', quantidade: state.boasPraticas.correcao, permissao: 'ROLE_BOAS_PRATICAS_POSTAR' },
        { nome: 'Ajuda - Chamados', modulo: 'ajuda', rota: 'ajuda-chamados-pendentes', quantidade: state.chamados, permissao: 'ROLE_AJUDA_CHAMADOS' },
        { nome: 'Solicitações de Cadastro', modulo: 'ferramentas', rota: 'ferramentas--solicitacao-de-cadastro', quantidade: state.solicitacoesDeCadastro, permissao: 'ROLE__FERRAMENTAS__SOLICITACOES_DE_CADASTRO' },
    ],

}

export default {
    state: State(),
    mutations,
    actions,
    getters,
}
